import { render, staticRenderFns } from "./createedit.vue?vue&type=template&id=99f026d8&scoped=true&"
import script from "./createedit.vue?vue&type=script&lang=js&"
export * from "./createedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f026d8",
  null
  
)

export default component.exports